import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { planList } from '../../redux/slice/PlanList';

export default function FreeOffer() {

    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const data = useSelector((state) => state.planList.data);
    const navigate = useNavigate() 

    const handleBuyPlan = () => {
        navigate('/signup');
    }

    useEffect(() => {
        setLoader(true);
        dispatch(planList({plan_type:'link', navigate })).finally(() => setLoader(false));
    }, []);

    const isFreePlan = (item) => {
        const planName = (item.plan_name || item.name || '').toLowerCase();
        const planType = (item.plan_type || '').toLowerCase();
        const price = parseFloat(item.price) || 0;

        return price === 0 || planName.includes('free') || planType === 'free';

    };

    return (
        <div>
            <section className="details-section">
                <div className="container">
                    {/* <h1 data-aos="zoom-in">What We Offer</h1> */}
                    <h1 className="offer-title text-center" data-aos="flip-up" data-aos-delay="200">
                        What We Offer
                    </h1>
                    <p
                        className="section-desc"
                        data-aos="fade-up"
                        data-aos-delay="150"
                    >
                        Explore our flexible plans designed for every user — from individuals
                        to professionals. Start free, upgrade anytime, and enjoy powerful tools
                        to grow your digital presence.
                    </p>
                    {data.length > 0 ?
                        <>
                            <div className="plans-grid">
                                {data?.filter((data) => data?.status === "Active")?.map((item) => (
                                    <div key={item._id} className="plan-card">
                                        <div className="d-flex align-items-center gap-2 plan-card-header d-flex justify-content">
                                            <h6 className="plan-title">{item.plan_name || item.name || 'Plan'}</h6>
                                            {/* {item._id === linkData?.plan_id ? */}
                                            {/* <span className={`status-badge status-${item.status?.toLowerCase()}`}>
                                                Active
                                            </span> */}
                                            {/* : ''} */}
                                        </div>
                                        <div className="plan-card-body">
                                          <div className="plan-field">
                                            <label>Price:</label>
                                            <div className="plan-price-container">
                                                {item.mrp && parseFloat(item.mrp) > 0 && parseFloat(item.price) < parseFloat(item.mrp) && (
                                                    <span className="plan-mrp">
                                                        {item.currency || '₹'}{item.mrp}
                                                    </span>
                                                )}
                                                <p className={`plan-value price-value ${(() => {
                                                    const price = parseFloat(item.price) || 0;
                                                    return price === 0 ? 'price-free' : '';
                                                })()}`}>
                                                    {(() => {
                                                        const price = parseFloat(item.price) || 0;
                                                        if (price === 0) {
                                                            return 'Free';
                                                        }
                                                        const [intPart, decPart] = String(item.price).split('.');
                                                        return (
                                                            <>
                                                                {item.currency || '₹'}{intPart}
                                                                {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                                <span style={{ fontSize: '0.6em' }}> INR</span>
                                                            </>
                                                        );
                                                    })()}
                                                </p>
                                            </div>
                                            {(parseFloat(item.price_usd) > 0 || parseFloat(item.mrp_usd) > 0) && (
                                                <div className="plan-price-container mt-1">
                                                    {item.mrp_usd && parseFloat(item.mrp_usd) > 0 && parseFloat(item.price_usd) < parseFloat(item.mrp_usd) && (
                                                        <span className="plan-mrp">
                                                            ${item.mrp_usd}
                                                        </span>
                                                    )}
                                                    <p className="plan-value price-value">
                                                        {(() => {
                                                            const [intPart, decPart] = String(item.price_usd).split('.');
                                                            return (
                                                                <>
                                                                    ${intPart}
                                                                    {decPart ? <span style={{ fontSize: '0.6em' }}>.{decPart}</span> : null}
                                                                    <span style={{ fontSize: '0.6em' }}> USD</span>
                                                                </>
                                                            );
                                                        })()}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                            {item.description && (
                                                <div className="plan-field">
                                                    <label>Description:</label>
                                                    <p className="plan-value">{item.description}</p>
                                                </div>
                                            )}

                                            {(item.days_validity || item.validity_days || item.validity || item.days) && (
                                                <div className="plan-field">
                                                    <label>Days Validity:</label>
                                                    <p className="plan-value validity-days">
                                                        {(() => {
                                                            const days = item.days_validity || item.validity_days || item.validity || item.days;
                                                            return `${days} ${days === 1 ? 'day' : 'days'}`;
                                                        })()}
                                                    </p>
                                                </div>
                                            )}
                                            {/* {item.features && (
                                            <div className="plan-field">
                                                <label>Features:</label>
                                                <div className="plan-value">
                                                    {Array.isArray(item.features) ? (
                                                        <ul className="features-list">
                                                            {item.features.map((feature, idx) => (
                                                                <li key={idx}>{feature}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>{item.features}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )} */}
                                        </div>
                                        <div className="plan-card-footer">
                                            {isFreePlan(item) ? (
                                                <button
                                                    className="btn-plan-action btn-current"
                                                    disabled
                                                >
                                                    Current Plan
                                                </button>
                                            ) : (
                                                <button
                                                    className="btn-plan-action btn-buy"
                                                onClick={() => handleBuyPlan()}
                                                >
                                                    Buy Plan
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                        :
                        <div className='text-center no-data'>No plans found</div>}
                    {/* <div className="offerings-grid">
                        <div className="offering-card" data-aos="flip-left" data-aos-delay="200">
                            <h3>Free Plan</h3>
                            <div className="price">₹0 / month</div>
                            <ul className="features-list">
                                <li>✓ Up to 100 short links</li>
                                <li>✓ Basic analytics</li>
                                <li>✓ Link expiration (30 days)</li>
                                <li>✓ QR code generation</li>
                            </ul>
                            <div className="button-wrapper">
                                <button className="cta-button">Get Started Free</button>
                            </div>
                        </div>
                        <div className="offering-card pro" data-aos="flip-up" data-aos-delay="300">
                            <div className="card-content">
                                <h3>Pro Plan</h3>
                                <div className="price">₹499 / month</div>
                                <ul className="features-list">
                                    <li>✓ Up to 10,000 short links</li>
                                    <li>✓ Detailed analytics dashboard</li>
                                    <li>✓ No link expiration</li>
                                    <li>✓ Custom domains & branding</li>
                                    <li>✓ QR & API access</li>
                                </ul>
                            </div>
                            <div className="button-wrapper">
                                <button className="cta-button pro-btn">Go Pro</button>
                            </div>
                        </div>
                        <div className="offering-card premium" data-aos="flip-right" data-aos-delay="400">
                            <div className="card-content">
                                <h3>Premium Plan</h3>
                                <div className="price">₹999 / month</div>
                                <ul className="features-list">
                                    <li>✓ Unlimited short links</li>
                                    <li>✓ Advanced analytics & reports</li>
                                    <li>✓ No expiration</li>
                                    <li>✓ Full white-label branding</li>
                                    <li>✓ Priority 24/7 support</li>
                                    <li>✓ Complete API & integrations</li>
                                </ul>
                            </div>
                            <div className="button-wrapper">
                                <button className="cta-button premium-btn">Upgrade Now</button>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
        </div>
    )
}
